package redmcrosco.alex.farmatch.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ExitToApp
import androidx.compose.material.icons.filled.Home
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Star
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Check
import androidx.compose.material.icons.filled.AccountBox
import androidx.compose.material.icons.filled.Email
import androidx.compose.material.icons.filled.Phone
import androidx.compose.material.icons.filled.Place
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.lerp
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import farmatch.composeapp.generated.resources.*
import org.jetbrains.compose.resources.stringResource
import redmcrosco.alex.farmatch.PAYMENT_HUB_URL
import redmcrosco.alex.farmatch.models.*
import redmcrosco.alex.farmatch.utils.ItalianCfUtils
import redmcrosco.alex.farmatch.utils.TimeUtils

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ProfileScreen(
    viewModel: AuthViewModel,
    currentLanguage: String = "it",
    onLanguageChange: (String) -> Unit = {},
    onLogout: () -> Unit,
    onNavigateToPreferiti: () -> Unit,
    onNavigateToSupporto: () -> Unit,
    onNavigateToStorico: () -> Unit
) {
    val email = viewModel.currentUserEmail
    val role = viewModel.currentUserRole
    val currentUserFarmacista = viewModel.currentUserFarmacista
    val currentUserFarmacia = viewModel.currentUserFarmacia
    
    var isEditing by remember { mutableStateOf(false) }
    val scrollState = rememberScrollState()
    
    val themeColorHex = viewModel.selectedThemeColor.hex.removePrefix("0x").toLong(16)
    val themeColor = Color(themeColorHex)

    val sectionTitle = stringResource(Res.string.tab_profile)
    var nome by remember { mutableStateOf("") }
    var cognome by remember { mutableStateOf("") }
    var sesso by remember { mutableStateOf("") }
    var dataNascita by remember { mutableStateOf("") }
    var luogoNascita by remember { mutableStateOf("") }
    var cittadinanza by remember { mutableStateOf("") }
    var cf by remember { mutableStateOf("") }
    var piva by remember { mutableStateOf("") }
    var matricola by remember { mutableStateOf("") }
    var telefono by remember { mutableStateOf("") }
    var titoloStudio by remember { mutableStateOf("") }
    var comuneOperativita by remember { mutableStateOf("") }
    var capOperativita by remember { mutableStateOf("") }
    var indirizzo by remember { mutableStateOf("") }
    var citta by remember { mutableStateOf("") }
    var cap by remember { mutableStateOf("") }
    var provincia by remember { mutableStateOf("") }
    var regione by remember { mutableStateOf("") }
    var tipo by remember { mutableStateOf("") }
    
    // Campi Fiscali
    var regimeFiscale by remember { mutableStateOf("FORFETTARIO") }
    var percEnpaf by remember { mutableStateOf("2.0") }
    var ragioneSociale by remember { mutableStateOf("") }
    var codiceSDI by remember { mutableStateOf("") }
    var pec by remember { mutableStateOf("") }
    
    // Competenze
    val competenzePredefinite = listOf("Elettrocardiogramma", "Tamponi", "Galenica", "Deblistering", "Gestione amministrativa", "Cosmesi", "Nutrizione", "Vaccinazione", "Omeopatia")
    val selectedSkills = remember { mutableStateListOf<String>() }
    var showOtherSkillField by remember { mutableStateOf(false) }
    var otherSkillText by remember { mutableStateOf("") }
    var expandedCompetenze by remember { mutableStateOf(false) }

    // Stati per i menu a tendina geografici
    var expRegione by remember { mutableStateOf(false) }
    var expProvincia by remember { mutableStateOf(false) }
    var expComune by remember { mutableStateOf(false) }
    var expCap by remember { mutableStateOf(false) }

    // Sincronizza lo stato locale quando i dati dal ViewModel cambiano
    LaunchedEffect(currentUserFarmacista, currentUserFarmacia, role) {
        if (role == UserRole.FARMACISTA && currentUserFarmacista != null) {
            nome = currentUserFarmacista.nome
            cognome = currentUserFarmacista.cognome
            sesso = currentUserFarmacista.sesso ?: ""
            dataNascita = currentUserFarmacista.dataNascita ?: ""
            luogoNascita = currentUserFarmacista.luogoNascita ?: ""
            cittadinanza = currentUserFarmacista.cittadinanza ?: ""
            cf = currentUserFarmacista.codiceFiscale ?: ""
            piva = currentUserFarmacista.partitaIva
            matricola = currentUserFarmacista.numeroIscrizioneOrdine ?: ""
            telefono = currentUserFarmacista.telefono ?: ""
            titoloStudio = currentUserFarmacista.titoloStudio ?: ""
            regione = currentUserFarmacista.regioneOperativita ?: ""
            provincia = currentUserFarmacista.provinciaOperativita ?: ""
            comuneOperativita = currentUserFarmacista.comuneOperativita ?: ""
            capOperativita = currentUserFarmacista.capOperativita ?: ""
            regimeFiscale = currentUserFarmacista.regimeFiscale ?: "FORFETTARIO"
            percEnpaf = currentUserFarmacista.percEnpaf.toString()
            selectedSkills.clear()
            selectedSkills.addAll(currentUserFarmacista.competenze)
        } else if (role == UserRole.FARMACIA && currentUserFarmacia != null) {
            nome = currentUserFarmacia.nomeFarmacia
            ragioneSociale = currentUserFarmacia.ragioneSociale ?: ""
            piva = currentUserFarmacia.partitaIva
            cf = currentUserFarmacia.codiceFiscale ?: ""
            codiceSDI = currentUserFarmacia.codiceSDI ?: ""
            pec = currentUserFarmacia.pec ?: ""
            matricola = currentUserFarmacia.numeroIscrizioneOrdineDirettore ?: ""
            telefono = currentUserFarmacia.telefono ?: ""
            indirizzo = currentUserFarmacia.indirizzo ?: ""
            citta = currentUserFarmacia.citta ?: ""
            cap = currentUserFarmacia.cap ?: ""
            provincia = currentUserFarmacia.provincia ?: ""
            regione = currentUserFarmacia.regione ?: ""
            tipo = currentUserFarmacia.tipo ?: ""
        }
    }

    var errorMessage by remember { mutableStateOf<String?>(null) }
    var showErrorDialog by remember { mutableStateOf(false) }

    if (showErrorDialog && errorMessage != null) {
        AlertDialog(
            onDismissRequest = { showErrorDialog = false },
            title = { Text(stringResource(Res.string.inconsistent_data)) },
            text = { Text(errorMessage!!) },
            confirmButton = {
                Button(onClick = { showErrorDialog = false }) {
                    Text(stringResource(Res.string.got_it))
                }
            }
        )
    }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .verticalScroll(scrollState),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Spacer(modifier = Modifier.height(16.dp))

        // --- SEZIONE CRUSCOTTO (UNIFORME ALLA HOME) ---
        Card(
            modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
            colors = CardDefaults.cardColors(
                containerColor = lerp(Color.White, themeColor, 0.15f)
            ),
            shape = RoundedCornerShape(16.dp),
            border = androidx.compose.foundation.BorderStroke(
                width = 0.5.dp,
                color = if (themeColor == Color.White) Color.LightGray else themeColor.copy(alpha = 0.2f)
            ),
            elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
        ) {
            Row(modifier = Modifier.fillMaxWidth().height(IntrinsicSize.Min)) {
                // BORDO LATERALE A SINISTRA
                Box(
                    modifier = Modifier
                        .width(6.dp)
                        .fillMaxHeight()
                        .background(if (themeColor == Color.White) Color.Gray else themeColor)
                )
                Column(modifier = Modifier.padding(16.dp)) {
                    Text(
                        text = sectionTitle,
                        style = MaterialTheme.typography.headlineMedium.copy(fontWeight = FontWeight.Bold),
                        color = if (themeColor == Color.White) Color.Black else themeColor
                    )
                }
            }
        }

        Spacer(modifier = Modifier.height(24.dp))

        Column(modifier = Modifier.fillMaxSize().padding(horizontal = 16.dp)) {
            // CARD IDENTITÀ
            Card(
                modifier = Modifier.fillMaxWidth().height(280.dp).border(1.dp, Color.LightGray, RoundedCornerShape(12.dp)),
                shape = RoundedCornerShape(12.dp),
                colors = CardDefaults.cardColors(containerColor = Color.White),
                elevation = CardDefaults.cardElevation(defaultElevation = 6.dp)
            ) {
                Column(modifier = Modifier.fillMaxSize()) {
                    Box(modifier = Modifier.fillMaxWidth().background(MaterialTheme.colorScheme.primary.copy(alpha = 0.1f)).padding(8.dp)) {
                        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                            Text(stringResource(Res.string.identity_header), style = MaterialTheme.typography.labelSmall, fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.primary)
                            Text(stringResource(Res.string.official_profile), style = MaterialTheme.typography.labelSmall, color = Color.Gray)
                        }
                    }

                    Row(modifier = Modifier.padding(16.dp)) {
                        Box(modifier = Modifier.size(100.dp).clip(RoundedCornerShape(8.dp)).background(Color(0xFFEEEEEE)).border(1.dp, Color.LightGray, RoundedCornerShape(8.dp)), contentAlignment = Alignment.Center) {
                            Icon(if(role == UserRole.FARMACIA) Icons.Default.Home else Icons.Default.Person, contentDescription = null, modifier = Modifier.size(60.dp), tint = Color.Gray)
                        }
                        Spacer(modifier = Modifier.width(16.dp))
                        Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
                            // --- BADGE ABBONAMENTO CON REINDIRIZZAMENTO ---
                            val subStatus = viewModel.subscriptionStatus
                            val uriHandler = LocalUriHandler.current
                            Surface(
                                color = if (subStatus.isPremium) Color(0xFFFFD700).copy(alpha = 0.2f) else Color.Gray.copy(alpha = 0.1f),
                                shape = RoundedCornerShape(4.dp),
                                modifier = Modifier.padding(bottom = 4.dp).clickable {
                                    if (!subStatus.isPremium) {
                                        val userId = viewModel.getUnivocoUtenteId() ?: ""
                                        val userRole = if (role == UserRole.FARMACIA) "FARMACIA" else "FARMACISTA"
                                        uriHandler.openUri("$PAYMENT_HUB_URL?role=$userRole&userId=$userId")
                                    }
                                },
                                border = if (subStatus.isPremium) null else androidx.compose.foundation.BorderStroke(0.5.dp, Color.Gray)
                            ) {
                                val label = if (subStatus.isPremium) {
                                    val expiryStr = subStatus.expiryDate?.let { TimeUtils.formatDate(it) } ?: "N/D"
                                    "PREMIUM FINO AL $expiryStr"
                                } else {
                                    "ACCOUNT BASE (CLICCA PER ATTIVARE)"
                                }
                                
                                Text(
                                    text = label,
                                    modifier = Modifier.padding(horizontal = 6.dp, vertical = 2.dp),
                                    fontSize = 8.sp,
                                    fontWeight = FontWeight.ExtraBold,
                                    color = if (subStatus.isPremium) Color(0xFFB8860B) else Color.Gray
                                )
                            }

                            if (role == UserRole.FARMACISTA) {
                                Row(horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                                    InfoRow(stringResource(Res.string.surname_label_caps), cognome.uppercase())
                                    InfoRow(stringResource(Res.string.name_label_caps), nome.uppercase())
                                    InfoRow(stringResource(Res.string.gender_label_caps), sesso)
                                }
                                Spacer(modifier = Modifier.height(4.dp))
                                Row(horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                                    InfoRow("EMAIL", email?.lowercase() ?: "N/D")
                                    InfoRow(stringResource(Res.string.born_on), dataNascita)
                                }
                                Spacer(modifier = Modifier.height(4.dp))
                                Row(horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                                    InfoRow(stringResource(Res.string.citizenship_label_caps), cittadinanza.uppercase())
                                    InfoRow(stringResource(Res.string.tax_code_label_caps), cf.uppercase())
                                    InfoRow(stringResource(Res.string.degree_label_caps), titoloStudio.uppercase())
                                }
                                Spacer(modifier = Modifier.height(4.dp))
                                Row(horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                                    InfoRow(stringResource(Res.string.operating_city_label_caps), comuneOperativita.uppercase())
                                    InfoRow(stringResource(Res.string.operating_cap_label_caps), capOperativita.uppercase())
                                    InfoRow(stringResource(Res.string.province_label_caps), provincia.uppercase())
                                    InfoRow("N. ORDINE", matricola)
                                }
                                Spacer(modifier = Modifier.height(4.dp))
                                Row(horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                                    InfoRow("REGIME", regimeFiscale)
                                    InfoRow("ENPAF", "$percEnpaf%")
                                }
                                Spacer(modifier = Modifier.height(8.dp))
                                if (selectedSkills.isNotEmpty()) {
                                    Text("COMPETENZE", style = MaterialTheme.typography.labelSmall, fontSize = 8.sp, color = Color.Gray, fontWeight = FontWeight.Bold)
                                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                                        selectedSkills.take(3).forEach { skill ->
                                            Surface(color = MaterialTheme.colorScheme.primary.copy(alpha = 0.1f), shape = RoundedCornerShape(4.dp)) {
                                                Text(skill, modifier = Modifier.padding(horizontal = 4.dp, vertical = 2.dp), fontSize = 8.sp, color = MaterialTheme.colorScheme.primary, fontWeight = FontWeight.Bold)
                                            }
                                        }
                                        if (selectedSkills.size > 3) {
                                            Text("+${selectedSkills.size - 3}", fontSize = 8.sp, color = Color.Gray)
                                        }
                                    }
                                }
                            } else {
                                InfoRow(stringResource(Res.string.pharmacy_name_label).uppercase(), nome.uppercase())
                                InfoRow("EMAIL", email?.lowercase() ?: "N/D")
                                if (ragioneSociale.isNotBlank()) InfoRow("RAGIONE SOCIALE", ragioneSociale.uppercase())
                                InfoRow(stringResource(Res.string.address_label_caps), "$indirizzo, $cap $citta ($provincia)")
                                InfoRow(stringResource(Res.string.region_label_caps), regione.uppercase())
                                Row(horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                                    InfoRow(stringResource(Res.string.vat_label_caps), piva)
                                    InfoRow("CODICE SDI", codiceSDI.ifBlank { "N/D" })
                                    InfoRow("PEC", pec.ifBlank { "N/D" })
                                }
                                InfoRow("MATRICOLA DIR.", matricola)
                            }
                        }
                    }
                    Spacer(modifier = Modifier.weight(1f))
                    Row(modifier = Modifier.fillMaxWidth().padding(16.dp), horizontalArrangement = Arrangement.End, verticalAlignment = Alignment.Bottom) {
                        Column(horizontalAlignment = Alignment.CenterHorizontally) {
                            Text(stringResource(Res.string.digital_signature), fontSize = 8.sp, color = Color.Gray)
                            Text(nome, fontFamily = FontFamily.Cursive, fontSize = 22.sp, fontWeight = FontWeight.Bold, color = Color.DarkGray)
                            HorizontalDivider(
                                modifier = Modifier.width(120.dp),
                                thickness = 1.dp,
                                color = Color.LightGray
                            )
                        }
                    }
                }
            }

            Spacer(modifier = Modifier.height(24.dp))

            if (isEditing) {
                Card(modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(12.dp), colors = CardDefaults.cardColors(containerColor = Color.White)) {
                    Column(modifier = Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
                        if (role == UserRole.FARMACISTA) {
                            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                OutlinedTextField(value = nome, onValueChange = { nome = it }, label = { Text(stringResource(Res.string.name_label)) }, modifier = Modifier.weight(1f))
                                OutlinedTextField(value = cognome, onValueChange = { cognome = it }, label = { Text(stringResource(Res.string.surname_label)) }, modifier = Modifier.weight(1f))
                            }
                            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
                                Text(stringResource(Res.string.gender_label_caps) + ": ")
                                RadioButton(selected = sesso == "M", onClick = { sesso = "M" })
                                Text("M")
                                RadioButton(selected = sesso == "F", onClick = { sesso = "F" })
                                Text("F")
                            }
                            OutlinedTextField(value = dataNascita, onValueChange = { dataNascita = it }, label = { Text(stringResource(Res.string.birth_date_label)) }, modifier = Modifier.fillMaxWidth())
                            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                OutlinedTextField(value = luogoNascita, onValueChange = { luogoNascita = it }, label = { Text(stringResource(Res.string.birth_place_label)) }, modifier = Modifier.weight(1f))
                                OutlinedTextField(value = cittadinanza, onValueChange = { cittadinanza = it }, label = { Text(stringResource(Res.string.citizenship_label)) }, modifier = Modifier.weight(1f))
                            }
                            OutlinedTextField(value = cf, onValueChange = { cf = it }, label = { Text(stringResource(Res.string.tax_code_label)) }, modifier = Modifier.fillMaxWidth())
                            OutlinedTextField(value = piva, onValueChange = { piva = it }, label = { Text(stringResource(Res.string.vat_number)) }, modifier = Modifier.fillMaxWidth())
                            OutlinedTextField(value = matricola, onValueChange = { matricola = it }, label = { Text(stringResource(Res.string.order_registration_label)) }, modifier = Modifier.fillMaxWidth())
                            
                            // --- DATI FISCALI FARMACISTA ---
                            Text("Dati Fiscali", style = MaterialTheme.typography.labelMedium, color = MaterialTheme.colorScheme.primary, fontWeight = FontWeight.Bold)
                            
                            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                EditableDropdownField(
                                    label = "Regime Fiscale",
                                    value = regimeFiscale,
                                    onValueChange = { regimeFiscale = it },
                                    options = listOf("FORFETTARIO", "ORDINARIO", "MINIMI"),
                                    modifier = Modifier.weight(1f)
                                )
                                OutlinedTextField(
                                    value = percEnpaf,
                                    onValueChange = { percEnpaf = it },
                                    label = { Text("% ENPAF") },
                                    modifier = Modifier.weight(0.5f),
                                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal)
                                )
                            }

                            // --- GESTIONE COMPETENZE IN MODIFICA ---
                            Text("Competenze Professionali", style = MaterialTheme.typography.labelMedium, color = MaterialTheme.colorScheme.primary, fontWeight = FontWeight.Bold)
                            ExposedDropdownMenuBox(
                                expanded = expandedCompetenze,
                                onExpandedChange = { expandedCompetenze = !expandedCompetenze },
                                modifier = Modifier.fillMaxWidth()
                            ) {
                                OutlinedTextField(
                                    value = if (selectedSkills.isEmpty()) "Aggiungi competenze..." else "${selectedSkills.size} selezionate",
                                    onValueChange = {},
                                    readOnly = true,
                                    trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expandedCompetenze) },
                                    modifier = Modifier.menuAnchor(MenuAnchorType.PrimaryNotEditable, true).fillMaxWidth(),
                                    shape = RoundedCornerShape(12.dp)
                                )
                                ExposedDropdownMenu(expanded = expandedCompetenze, onDismissRequest = { expandedCompetenze = false }) {
                                    competenzePredefinite.forEach { skill ->
                                        val isSelected = selectedSkills.contains(skill)
                                        DropdownMenuItem(
                                            text = {
                                                Row(verticalAlignment = Alignment.CenterVertically) {
                                                    Checkbox(checked = isSelected, onCheckedChange = null)
                                                    Spacer(Modifier.width(8.dp))
                                                    Text(skill)
                                                }
                                            },
                                            onClick = { if (isSelected) selectedSkills.remove(skill) else selectedSkills.add(skill) }
                                        )
                                    }
                                    DropdownMenuItem(
                                        text = { 
                                            Row(verticalAlignment = Alignment.CenterVertically) {
                                                Icon(Icons.Default.Add, contentDescription = null, modifier = Modifier.size(18.dp))
                                                Spacer(Modifier.width(8.dp))
                                                Text("Altro...") 
                                            }
                                        },
                                        onClick = { showOtherSkillField = !showOtherSkillField; expandedCompetenze = false }
                                    )
                                }
                            }

                            if (showOtherSkillField) {
                                Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                                    OutlinedTextField(
                                        value = otherSkillText,
                                        onValueChange = { otherSkillText = it },
                                        label = { Text("Nuova competenza") },
                                        modifier = Modifier.weight(1f),
                                        shape = RoundedCornerShape(12.dp)
                                    )
                                    IconButton(onClick = {
                                        if (otherSkillText.isNotBlank()) {
                                            if (!selectedSkills.contains(otherSkillText.trim())) selectedSkills.add(otherSkillText.trim())
                                            otherSkillText = ""; showOtherSkillField = false
                                        }
                                    }) { Icon(Icons.Default.Check, contentDescription = null, tint = MaterialTheme.colorScheme.primary) }
                                }
                            }

                            if (selectedSkills.isNotEmpty()) {
                                @OptIn(ExperimentalLayoutApi::class)
                                FlowRow(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                    selectedSkills.forEach { skill ->
                                        InputChip(
                                            selected = true,
                                            onClick = { selectedSkills.remove(skill) },
                                            label = { Text(skill, fontSize = 11.sp) },
                                            trailingIcon = { Icon(Icons.Default.Close, contentDescription = null, modifier = Modifier.size(14.dp)) }
                                        )
                                    }
                                }
                            }

                            Text(
                                text = stringResource(Res.string.operating_area_title),
                                style = MaterialTheme.typography.labelMedium,
                                color = MaterialTheme.colorScheme.primary,
                                fontWeight = FontWeight.Bold
                            )
                            Spacer(modifier = Modifier.height(8.dp))

                            // REGIONE
                            ExposedDropdownMenuBox(
                                expanded = expRegione,
                                onExpandedChange = { expRegione = !expRegione },
                                modifier = Modifier.fillMaxWidth()
                            ) {
                                OutlinedTextField(
                                    value = regione,
                                    onValueChange = {},
                                    readOnly = true,
                                    label = { Text(stringResource(Res.string.region_label)) },
                                    trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expRegione) },
                                    modifier = Modifier.menuAnchor(MenuAnchorType.PrimaryNotEditable, true).fillMaxWidth(),
                                    shape = RoundedCornerShape(12.dp)
                                )
                                ExposedDropdownMenu(expanded = expRegione, onDismissRequest = { expRegione = false }) {
                                    viewModel.listaRegioni.forEach { r ->
                                        DropdownMenuItem(
                                            text = { Text(r) },
                                            onClick = {
                                                regione = r
                                                provincia = ""
                                                comuneOperativita = ""
                                                capOperativita = ""
                                                viewModel.updateProvincePerRegione(r)
                                                expRegione = false
                                            }
                                        )
                                    }
                                }
                            }

                            // PROVINCIA E COMUNE
                            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                ExposedDropdownMenuBox(
                                    expanded = expProvincia,
                                    onExpandedChange = { if (regione.isNotEmpty()) expProvincia = !expProvincia },
                                    modifier = Modifier.weight(1f)
                                ) {
                                    OutlinedTextField(
                                        value = provincia,
                                        onValueChange = {},
                                        readOnly = true,
                                        enabled = regione.isNotEmpty(),
                                        label = { Text(stringResource(Res.string.province_label)) },
                                        trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expProvincia) },
                                        modifier = Modifier.menuAnchor(MenuAnchorType.PrimaryNotEditable, true).fillMaxWidth(),
                                        shape = RoundedCornerShape(12.dp)
                                    )
                                    ExposedDropdownMenu(expanded = expProvincia, onDismissRequest = { expProvincia = false }) {
                                        viewModel.listaProvince.forEach { p ->
                                            DropdownMenuItem(
                                                text = { Text(p) },
                                                onClick = {
                                                    provincia = p
                                                    comuneOperativita = ""
                                                    capOperativita = ""
                                                    viewModel.updateComuniPerProvincia(p)
                                                    expProvincia = false
                                                }
                                            )
                                        }
                                    }
                                }

                                ExposedDropdownMenuBox(
                                    expanded = expComune,
                                    onExpandedChange = { if (provincia.isNotEmpty()) expComune = !expComune },
                                    modifier = Modifier.weight(2f)
                                ) {
                                    OutlinedTextField(
                                        value = comuneOperativita,
                                        onValueChange = {},
                                        readOnly = true,
                                        enabled = provincia.isNotEmpty(),
                                        label = { Text(stringResource(Res.string.city_row)) },
                                        trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expComune) },
                                        modifier = Modifier.menuAnchor(MenuAnchorType.PrimaryNotEditable, true).fillMaxWidth(),
                                        shape = RoundedCornerShape(12.dp)
                                    )
                                    ExposedDropdownMenu(expanded = expComune, onDismissRequest = { expComune = false }) {
                                        viewModel.listaComuni.forEach { c ->
                                            DropdownMenuItem(
                                                text = { Text(c) },
                                                onClick = {
                                                    comuneOperativita = c
                                                    capOperativita = ""
                                                    viewModel.updateCapPerComune(c)
                                                    expComune = false
                                                }
                                            )
                                        }
                                    }
                                }
                            }

                            // CAP
                            ExposedDropdownMenuBox(
                                expanded = expCap,
                                onExpandedChange = { if (comuneOperativita.isNotEmpty()) expCap = !expCap },
                                modifier = Modifier.fillMaxWidth()
                            ) {
                                OutlinedTextField(
                                    value = capOperativita,
                                    onValueChange = {},
                                    readOnly = true,
                                    enabled = comuneOperativita.isNotEmpty(),
                                    label = { Text(stringResource(Res.string.cap_label)) },
                                    trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expCap) },
                                    modifier = Modifier.menuAnchor(MenuAnchorType.PrimaryNotEditable, true).fillMaxWidth(),
                                    shape = RoundedCornerShape(12.dp)
                                )
                                ExposedDropdownMenu(expanded = expCap, onDismissRequest = { expCap = false }) {
                                    viewModel.listaCap.forEach { cp ->
                                        DropdownMenuItem(
                                            text = { Text(cp) },
                                            onClick = {
                                                capOperativita = cp
                                                expCap = false
                                            }
                                        )
                                    }
                                }
                            }
                        } else {
                            OutlinedTextField(value = nome, onValueChange = { nome = it }, label = { Text(stringResource(Res.string.pharmacy_name_label)) }, modifier = Modifier.fillMaxWidth())
                            OutlinedTextField(value = ragioneSociale, onValueChange = { ragioneSociale = it }, label = { Text("Ragione Sociale") }, modifier = Modifier.fillMaxWidth())
                            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                OutlinedTextField(value = piva, onValueChange = { piva = it }, label = { Text(stringResource(Res.string.vat_number)) }, modifier = Modifier.weight(1f))
                                OutlinedTextField(value = cf, onValueChange = { cf = it }, label = { Text(stringResource(Res.string.tax_code_label)) }, modifier = Modifier.weight(1f))
                            }
                            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                OutlinedTextField(value = codiceSDI, onValueChange = { codiceSDI = it }, label = { Text("Codice SDI") }, modifier = Modifier.weight(0.5f))
                                OutlinedTextField(value = pec, onValueChange = { pec = it }, label = { Text("PEC") }, modifier = Modifier.weight(1f))
                            }
                            OutlinedTextField(value = matricola, onValueChange = { matricola = it }, label = { Text(stringResource(Res.string.director_registration_label)) }, modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(12.dp))
                            OutlinedTextField(value = indirizzo, onValueChange = { indirizzo = it }, label = { Text(stringResource(Res.string.address_label)) }, modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(12.dp))
                            
                            // REGIONE FARMACIA
                            ExposedDropdownMenuBox(
                                expanded = expRegione,
                                onExpandedChange = { expRegione = !expRegione },
                                modifier = Modifier.fillMaxWidth()
                            ) {
                                OutlinedTextField(
                                    value = regione,
                                    onValueChange = {},
                                    readOnly = true,
                                    label = { Text(stringResource(Res.string.region_label)) },
                                    trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expRegione) },
                                    modifier = Modifier.menuAnchor(MenuAnchorType.PrimaryNotEditable, true).fillMaxWidth(),
                                    shape = RoundedCornerShape(12.dp)
                                )
                                ExposedDropdownMenu(expanded = expRegione, onDismissRequest = { expRegione = false }) {
                                    viewModel.listaRegioni.forEach { r ->
                                        DropdownMenuItem(
                                            text = { Text(r) },
                                            onClick = {
                                                regione = r
                                                provincia = ""
                                                citta = ""
                                                cap = ""
                                                viewModel.updateProvincePerRegione(r)
                                                expRegione = false
                                            }
                                        )
                                    }
                                }
                            }

                            // PROVINCIA E CITTA FARMACIA
                            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                ExposedDropdownMenuBox(
                                    expanded = expProvincia,
                                    onExpandedChange = { if (regione.isNotEmpty()) expProvincia = !expProvincia },
                                    modifier = Modifier.weight(1f)
                                ) {
                                    OutlinedTextField(
                                        value = provincia,
                                        onValueChange = {},
                                        readOnly = true,
                                        enabled = regione.isNotEmpty(),
                                        label = { Text(stringResource(Res.string.province_label)) },
                                        trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expProvincia) },
                                        modifier = Modifier.menuAnchor(MenuAnchorType.PrimaryNotEditable, true).fillMaxWidth(),
                                        shape = RoundedCornerShape(12.dp)
                                    )
                                    ExposedDropdownMenu(expanded = expProvincia, onDismissRequest = { expProvincia = false }) {
                                        viewModel.listaProvince.forEach { p ->
                                            DropdownMenuItem(
                                                text = { Text(p) },
                                                onClick = {
                                                    provincia = p
                                                    citta = ""
                                                    cap = ""
                                                    viewModel.updateComuniPerProvince(listOf(p))
                                                    expProvincia = false
                                                }
                                            )
                                        }
                                    }
                                }

                                ExposedDropdownMenuBox(
                                    expanded = expComune,
                                    onExpandedChange = { if (provincia.isNotEmpty()) expComune = !expComune },
                                    modifier = Modifier.weight(2f)
                                ) {
                                    OutlinedTextField(
                                        value = citta,
                                        onValueChange = {},
                                        readOnly = true,
                                        enabled = provincia.isNotEmpty(),
                                        label = { Text(stringResource(Res.string.city_label)) },
                                        trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expComune) },
                                        modifier = Modifier.menuAnchor(MenuAnchorType.PrimaryNotEditable, true).fillMaxWidth(),
                                        shape = RoundedCornerShape(12.dp)
                                    )
                                    ExposedDropdownMenu(expanded = expComune, onDismissRequest = { expComune = false }) {
                                        viewModel.listaComuni.forEach { c ->
                                            DropdownMenuItem(
                                                text = { Text(c) },
                                                onClick = {
                                                    citta = c
                                                    cap = ""
                                                    viewModel.updateCapPerComune(c)
                                                    expComune = false
                                                }
                                            )
                                        }
                                    }
                                }
                            }

                            // CAP FARMACIA
                            ExposedDropdownMenuBox(
                                expanded = expCap,
                                onExpandedChange = { if (citta.isNotEmpty()) expCap = !expCap },
                                modifier = Modifier.fillMaxWidth()
                            ) {
                                OutlinedTextField(
                                    value = cap,
                                    onValueChange = {},
                                    readOnly = true,
                                    enabled = citta.isNotEmpty(),
                                    label = { Text(stringResource(Res.string.cap_label)) },
                                    trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expCap) },
                                    modifier = Modifier.menuAnchor(MenuAnchorType.PrimaryNotEditable, true).fillMaxWidth(),
                                    shape = RoundedCornerShape(12.dp)
                                )
                                ExposedDropdownMenu(expanded = expCap, onDismissRequest = { expCap = false }) {
                                    viewModel.listaCap.forEach { cp ->
                                        DropdownMenuItem(
                                            text = { Text(cp) },
                                            onClick = {
                                                cap = cp
                                                expCap = false
                                            }
                                        )
                                    }
                                }
                            }
                            OutlinedTextField(value = tipo, onValueChange = { tipo = it }, label = { Text("Tipo (Galenica, ecc. - Facoltativo)") }, modifier = Modifier.fillMaxWidth())
                        }
                        
                        OutlinedTextField(value = telefono, onValueChange = { telefono = it }, label = { Text(stringResource(Res.string.phone_label)) }, modifier = Modifier.fillMaxWidth())

                        if (errorMessage != null) {
                            Text(errorMessage!!, color = Color.Red, style = MaterialTheme.typography.labelSmall)
                        }

                        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                            Button(
                                onClick = { 
                                    errorMessage = null
                                    if (role == UserRole.FARMACISTA) {
                                        val nomePuro = nome.trim()
                                        val cognomePuro = cognome.trim()
                                        val cfPuro = cf.uppercase().trim()
                                        
                                        val erroreValidazione = ItalianCfUtils.validaTutto(nomePuro, cognomePuro, sesso, dataNascita, cfPuro)
                                        
                                        if (nomePuro.isBlank() || cognomePuro.isBlank() || sesso.isBlank() || dataNascita.isBlank()) {
                                            errorMessage = "Errore: Compila tutti i campi obbligatori!"
                                            showErrorDialog = true
                                        } else if (erroreValidazione != null) {
                                            errorMessage = erroreValidazione
                                            showErrorDialog = true
                                        } else {
                                            viewModel.updateProfile(Farmacista(
                                                nome = nomePuro, cognome = cognomePuro, sesso = sesso,
                                                codiceFiscale = cfPuro, dataNascita = dataNascita,
                                                numeroIscrizioneOrdine = matricola.trim(),
                                                luogoNascita = luogoNascita, cittadinanza = cittadinanza,
                                                titoloStudio = titoloStudio, email = email ?: "", 
                                                partitaIva = piva, telefono = telefono,
                                                regimeFiscale = regimeFiscale,
                                                percEnpaf = percEnpaf.toDoubleOrNull() ?: 2.0,
                                                regioneOperativita = regione,
                                                provinciaOperativita = provincia,
                                                comuneOperativita = comuneOperativita, 
                                                capOperativita = capOperativita,
                                                competenze = selectedSkills.toList()
                                            ))
                                            isEditing = false
                                            errorMessage = null
                                        }
                                    } else {
                                        if (nome.isBlank() || piva.isBlank() || cap.isBlank() || citta.isBlank() || provincia.isBlank()) {
                                            errorMessage = "Dati obbligatori mancanti"
                                        } else {
                                            viewModel.updateFarmaciaProfile(Farmacia(
                                                nomeFarmacia = nome, ragioneSociale = ragioneSociale,
                                                partitaIva = piva, codiceFiscale = cf,
                                                codiceSDI = codiceSDI, pec = pec,
                                                numeroIscrizioneOrdineDirettore = matricola.trim(),
                                                indirizzo = indirizzo, citta = citta, cap = cap,
                                                provincia = provincia, regione = regione,
                                                telefono = telefono, email = email ?: "", tipo = tipo
                                            ))
                                            isEditing = false
                                        }
                                    }
                                },
                                modifier = Modifier.weight(1f)
                            ) { Text(stringResource(Res.string.save_button)) }
                            OutlinedButton(
                                onClick = { 
                                    // RIPRISTINA I DATI ORIGINALI
                                    if (role == UserRole.FARMACISTA && currentUserFarmacista != null) {
                                        nome = currentUserFarmacista.nome
                                        cognome = currentUserFarmacista.cognome
                                        sesso = currentUserFarmacista.sesso ?: ""
                                        dataNascita = currentUserFarmacista.dataNascita ?: ""
                                        luogoNascita = currentUserFarmacista.luogoNascita ?: ""
                                        cittadinanza = currentUserFarmacista.cittadinanza ?: ""
                                        cf = currentUserFarmacista.codiceFiscale ?: ""
                                        piva = currentUserFarmacista.partitaIva
                                        telefono = currentUserFarmacista.telefono ?: ""
                                        titoloStudio = currentUserFarmacista.titoloStudio ?: ""
                                        comuneOperativita = currentUserFarmacista.comuneOperativita ?: ""
                                        capOperativita = currentUserFarmacista.capOperativita ?: ""
                                        provincia = currentUserFarmacista.provinciaOperativita ?: ""
                                    } else if (role == UserRole.FARMACIA && currentUserFarmacia != null) {
                                        nome = currentUserFarmacia.nomeFarmacia
                                        piva = currentUserFarmacia.partitaIva
                                        cf = currentUserFarmacia.codiceFiscale ?: ""
                                        telefono = currentUserFarmacia.telefono ?: ""
                                        indirizzo = currentUserFarmacia.indirizzo ?: ""
                                        citta = currentUserFarmacia.citta ?: ""
                                        cap = currentUserFarmacia.cap ?: ""
                                        provincia = currentUserFarmacia.provincia ?: ""
                                        regione = currentUserFarmacia.regione ?: ""
                                        tipo = currentUserFarmacia.tipo ?: ""
                                    }
                                    errorMessage = null
                                    isEditing = false 
                                }, 
                                modifier = Modifier.weight(1f)
                            ) { Text(stringResource(Res.string.cancel_button)) }
                        }
                    }
                }
            } else {
                Button(onClick = { isEditing = true }, modifier = Modifier.fillMaxWidth()) { 
                    Text(if(role == UserRole.FARMACIA) stringResource(Res.string.edit_data_pharmacy) else stringResource(Res.string.edit_data_professional)) 
                }
                
                Spacer(modifier = Modifier.height(12.dp))
                
                OutlinedButton(
                    onClick = onNavigateToPreferiti,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Icon(AppIcons.Favorite, contentDescription = null, tint = Color.Red)
                    Spacer(Modifier.width(8.dp))
                    Text(stringResource(Res.string.my_favorites))
                }

                Spacer(modifier = Modifier.height(12.dp))

                OutlinedButton(
                    onClick = onNavigateToStorico,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Icon(Icons.Default.Check, contentDescription = null)
                    Spacer(Modifier.width(8.dp))
                    Text(stringResource(Res.string.storico_title))
                }

                Spacer(modifier = Modifier.height(12.dp))

                OutlinedButton(
                    onClick = onNavigateToSupporto,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Icon(Icons.Default.Star, contentDescription = null) // Placeholder, use appropriate icon
                    Spacer(Modifier.width(8.dp))
                    Text(stringResource(Res.string.support_feedback))
                }
            }
        }
    }
}

@Composable
fun InfoRow(label: String, value: String) {
    Column {
        Text(label, style = MaterialTheme.typography.labelSmall, fontSize = 9.sp, color = Color.Gray, fontWeight = FontWeight.Bold)
        Text(value, style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.SemiBold, color = Color.Black)
    }
}
